// import '@/pages/dashboard/sections/watch.css';

import WatchCoursesLoader from '@/pages/dashboard/loaders/watchCoursesLoader'
import WatchSeriesLoader from '@/pages/dashboard/loaders/watchSeriesLoader'
import { RootState } from '@/store';
import { addCurrentThemeClassToEle } from '@/utils';
import { useSelector } from 'react-redux';
import "./style.css"
export default function WatchLoader(props: any) {
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <div className={`${addCurrentThemeClassToEle(currentTheme, 'watchLoaderMainCon')}`}>
            {props.source && props.source === "watch" &&
                <div className='courseMain animate-pulse'>
                    {/* Course heading */}
                    <div className="h-[30px] mb-[25px] rounded w-[170px] watchLoaderMainCon_heading"></div>
                    <WatchCoursesLoader />
                </div>

            }
            <div 
                className={`${props.source && (props.source === "watch" || props.source === "test") && "mt-[30px]"} seriesMain animate-pulse`}>
                {/* Series heading */}
                <div className="h-[30px] mb-[25px] rounded w-[170px] watchLoaderMainCon_heading"></div>
                <WatchSeriesLoader />
            </div>
        </div>
    );
}
